export function num(){

}


/*
* 参数说明：
* number：要格式化的数字
* decimals：保留几位小数
* 小数点符号"."
* 千分位符号","
* 四舍五入取值
*/
num.prototype.Format = function (number, decimals = 2) {
    if (!number) {
        return "---"
    }
    number = (number + '').replace(/[^0-9+-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec)
        return '' + parseFloat(Math['round'](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2)) / k
    }
    var s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    var re = /(-?\d+)(\d{3})/
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, '$1' + "," + '$2')
    }

    if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(".")
}